module.exports = __webpack_public_path__ + "img/credit-card.acf1e2ce.png";